export interface MaritalStatusState {
  single: boolean;
  married: boolean;
}

export interface MaritalStatusAction {
  type: MaritalStatusType;
}

export enum MaritalStatusType {
  Single = "single",
  Married = "married",
}

export interface MaritalStatusFormValues {
  firstName: string;
  lastName: string;
}
